interface IslamicSymbolProps {
  size?: number;
  className?: string;
}

export function IslamicSymbol({ size = 24, className = "" }: IslamicSymbolProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Crescent Moon */}
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c1.54 0 3-.35 4.31-.99C13.57 19.81 11 16.11 11 12s2.57-7.81 5.31-9.01C15 2.35 13.54 2 12 2z"
        fill="currentColor"
        fillOpacity="0.9"
      />
      {/* Five-pointed Star */}
      <path
        d="M18.5 8.5l-1.02 2.07L15.41 11l2.07 1.02L18.5 14.5l1.02-2.07L21.59 11l-2.07-1.02L18.5 8.5z"
        fill="currentColor"
      />
      {/* Additional small star points for traditional look */}
      <circle cx="19" cy="7" r="0.8" fill="currentColor" fillOpacity="0.7" />
      <circle cx="20.5" cy="9" r="0.6" fill="currentColor" fillOpacity="0.7" />
    </svg>
  );
}
